import type { Locales } from './types/Locales';

export const APP_LOCALES = [
  'en-US',
  'nl-NL',
  'fr-FR',
] as const satisfies Locales[];
